import { AnalyticsItem, BreadcrumbList, Product } from 'apps/commerce/types.ts'

export const mapCategoriesToAnalyticsCategories = (
    categories: string[],
): Record<`item_category${number | ''}`, string> => {
    return categories.slice(0, 5).reduce(
        (result, category, index) => {
            result[`item_category${index === 0 ? '' : index + 1}`] = category
            return result
        },
        {} as Record<`item_category${number | ''}`, string>,
    )
}

export const mapProductCategoryToAnalyticsCategories = (category: string) => {
    return category.split('>').reduce(
        (result, category, index) => {
            result[`item_category${index === 0 ? '' : index + 1}`] = category
            return result
        },
        {} as Record<`item_category${number | ''}`, string>,
    )
}

export const mapProductCategoryFromOrderForm = (category: string[]) => {
    return category.reduce(
        (result, category, index) => {
            result[`item_category${index === 0 ? '' : index + 1}`] = category
            return result
        },
        {} as Record<`item_category${number | ''}`, string>,
    )
}

export const mapProductToAnalyticsItem = ({
    product,
    breadcrumbList,
    price,
    listPrice,
    index,
    item_list_id,
    item_list_name,
    quantity,
    categoriesOrderForm,
}: {
    product: Product
    breadcrumbList?: BreadcrumbList
    price?: number
    listPrice?: number
    index?: number
    item_list_id?: string
    item_list_name?: string
    quantity?: number
    categoriesOrderForm?: string[]
}): AnalyticsItem => {
    const { name, alternateName, productID, isVariantOf, inProductGroupWithID = '' } = product
    const categories = categoriesOrderForm
        ? mapProductCategoryFromOrderForm(categoriesOrderForm)
        : breadcrumbList?.itemListElement
        ? mapCategoriesToAnalyticsCategories(
            breadcrumbList?.itemListElement
                .map(({ name: _name }) => _name ?? '')
                .filter(Boolean) ?? [],
        )
        : mapProductCategoryToAnalyticsCategories(product.category ?? '')

    const discount = Number((price && listPrice ? listPrice - price : 0).toFixed(2))

    const obj = {
        // Important! otherwise Algolia and other analytics will not work
        item_id: `${inProductGroupWithID ?? 'error-003'}_${productID}`,
        quantity: quantity ?? 1,
        index: index ? index - 1 : -1, // Necessário devido à auto "correção" que o app da Sourei faz
        coupon: '',
        price: price ? price - discount : undefined, // Necessário devido à auto "correção" que o app da Sourei faz
        discount,
        item_name: isVariantOf?.name ?? alternateName ?? name ?? '',
        item_variant: name,
        item_brand: product.brand ? product.brand?.name : '',
        item_list_id: item_list_id ?? '',
        item_list_name: item_list_name ?? '',
        ...categories,
    }

    return obj
}

// Arquivo de interesse para o rollback da demanda #4561
// Este é um dos arquivos que foram (ou que poderão ser) alterados 
// para realização do rollback